<p-calendar class="p-calendar-time" [(ngModel)]="value" [id]="id" [placeholder]="placeholder" [hourFormat]="'12'"
    [stepMinute]="'1'" [showTime]="true" [timeOnly]="true" (onBlur)="onTouched()" [ariaLabel]="ariaLabel"
    inputStyleClass="p-inputtext-sm p-inputtext" (onShow)="onCalendarShow()" [focusTrap]="false" [tabindex]="index"
    (ngModelChange)="onTimeChange($event)" [disabled]="isDisabled"></p-calendar>

<div aria-live="polite" class="sr-only">
    {{ ariaMessage }}
</div>